export const getExpenseEntryMethod = isSummaryExpenses => {
  switch (isSummaryExpenses) {
    case 'yes':
      return 'Summary';
    case 'no':
      return 'Itemised';
    default:
      return null;
  }
};
